"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createClient = createClient;
var _routing = require("../../routing.cjs");
function createClient(api) {
  async function get(newsroomId, domain) {
    const url = _routing.routing.newsroomDomainsUrl.replace(':newsroom_id', String(newsroomId));
    const response = await api.get(`${url}/${domain}`);
    return response.domain;
  }
  async function list(newsroomId) {
    const url = _routing.routing.newsroomDomainsUrl.replace(':newsroom_id', String(newsroomId));
    const {
      domains
    } = await api.get(url);
    return domains;
  }
  async function link(newsroomId, payload) {
    const url = _routing.routing.newsroomDomainsUrl.replace(':newsroom_id', String(newsroomId));
    const {
      domain
    } = await api.post(url, {
      payload
    });
    return domain;
  }
  async function unlink(newsroomId, domain) {
    const url = _routing.routing.newsroomDomainsUrl.replace(':newsroom_id', String(newsroomId));
    return api.delete(`${url}/${domain}`);
  }
  async function check(newsroomId, domain) {
    const url = _routing.routing.newsroomDomainsUrl.replace(':newsroom_id', String(newsroomId));
    const response = await api.post(`${url}/${domain}/check`);
    return response.domain;
  }
  async function shareDnsInstructions(newsroomId, domain) {
    const url = _routing.routing.newsroomDomainsUrl.replace(':newsroom_id', String(newsroomId));
    const response = await api.post(`${url}/${domain}/share`);
    return response.sharable_dns_instructions;
  }
  return {
    get,
    list,
    link,
    unlink,
    check,
    shareDnsInstructions
  };
}